import styled, { css } from 'styled-components'
import { Card } from 'components/forms'
import { MEDIA } from 'src/utils'

export const CardContainer = styled.div`
  background: var(--the-white);
  padding: 8px 0 0 0;
  position: sticky;
  top: 61px;
  z-index: 2;
  @media screen and ${MEDIA.DESKTOP_UP} {
    top: 144px;
  }
`

export const StickyCard = styled(Card)`
  background-color: var(--the-white);
  padding: 16px;
  width: 100%;
  max-width: 752px;
`

export const PhotoContainer = styled.div`
  border-radius: 99px;
  flex: 0 0 40px;
  min-width: 40px;
  min-height: 40px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-image: url("${props => props.src}");
  background-size: ${({ setDefaultPhoto }) => setDefaultPhoto ? 'contain' : 'cover'};
  background-repeat: no-repeat;
  background-position: center center;
`

export const Summary = styled.section`
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    > div {
      display: flex;
      align-items: center;
      gap: 16px;
    }
    .pet-info {
      display: flex;
      gap: 4px;
      flex-direction: column;
      overflow: hidden;
    }
    section.price {
      height: 40px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      flex-direction: column;
      background-color: var(--pet-anjo-lighter-blue);
      padding: 8px;
      border-radius: .8rem;
    }
    section.bath-package {
      background-color: var(--success-pastel);
      height: 32px;

      @media screen and ${MEDIA.MOBILE} {
        height: 24px;
     }
    }
    section {
      > p.pet-name {
        color: var(--gray-2);
        font-size: 1.6rem;
        font-weight: 600;
        line-height: 2.4rem;
        }
        > p.service-name {
          color: var(--gray-5);
          font-size: 1.2rem;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.8rem;
      }
    }

    @media screen and ${MEDIA.MOBILE} {
      ${({ isPackage }) => isPackage && css`
        flex-direction: column;
        align-items: flex-start;
     `}
    }
`

export const Price = styled.div`
    font-family: var(--primary-font);
    font-weight: 600;
    line-height: 2.4rem;
    display: ${props => props.campaign ? 'flex' : 'block'};
    font-size: ${props => props.campaign ? '16px' : '13px'};
    margin-top: ${props => props.marginTop ? '4px' : '0px'};
    color: var(--gray-2);
    gap: 8px;
    align-items: center;
    text-align: right;
    ${({ price }) => price && css`
      color: var(--cobasi-blue-light-8);
      font-size: 1.6rem;
      line-height: 120%;
    `}
    ${({ previousPrice }) => previousPrice && css`
      color: var(--gray-5);
      text-decoration: line-through;
      font-size: 1.2rem;
      line-height: 1.8rem;
      font-weight: 600;
      text-align: end;
    `}

    span {
      font-size: 12px;
      font-weight: 600;
      color: var(--success);
    }

    ${({ isPackage }) => isPackage && css`
      display: flex;
      flex-direction: row;
      font-size: 10px;
      font-weight: 400;
      color: var(--gray-7);
      gap: 4px;
    `}

`

export const DiscountAmount = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    background: var(--success-pastel);
    border-radius: 8px;
    margin-left: 8px;
    padding: 4px 8px;
    color: var(--success);
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: normal;
    width: fit-content;
    white-space: nowrap;
    margin-left: auto;
    margin-top: 16px;
`

export const CalcPrice = styled.div`
    display: ${props => props.expanded ? 'flex' : 'none'};
    align-items: center;
    gap: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    color: var(--gray-2);
    margin: 10px 0 26px;
    padding: 0 15px;

    ${({ finalStep }) => finalStep && css`
      div {
        hr {
          margin-top: 16px;
        }
      }

      margin: 16px 0;
    `}

    ${({ onlyScheduling }) => onlyScheduling && css`
      margin: 24px 0 0;
    `}
`
